module.exports = __webpack_public_path__ + "static/img/1.26a841f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/1.png
// module id = uKOX
// module chunks = 0